import { Link } from 'react-router-dom'
import { GraduationCap, ArrowLeft } from 'lucide-react'

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-card/80 backdrop-blur-md border-b">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <GraduationCap className="w-8 h-8 text-primary" />
            <span className="text-xl font-bold">
              Nomad<span className="text-[#EF4135]">Lexis</span>
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">
          Términos y Condiciones
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          Última actualización: febrero 2026
        </p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground">
          {/* 1 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              1. Descripción del servicio
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              NomadLexis es una plataforma educativa en línea que ofrece un programa de francés aplicado al turismo, hotelería y comercio. El programa incluye 4 unidades, 16 lecciones, 64 contenidos y 384 ejercicios interactivos, además de talleres en vivo y un certificado de finalización.
            </p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              2. Registro y cuenta
            </h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Para acceder a la plataforma, debe crear una cuenta con un correo electrónico válido.</li>
              <li>Usted es responsable de mantener la confidencialidad de sus credenciales.</li>
              <li>El registro está reservado a personas de 16 años o más.</li>
              <li>La información proporcionada debe ser veraz y estar actualizada.</li>
            </ul>
          </section>

          {/* 3 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              3. Pagos y suscripción
            </h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Los pagos se procesan de forma segura a través de MercadoPago.</li>
              <li>Los precios se muestran en pesos chilenos (CLP) e incluyen los impuestos aplicables.</li>
              <li>El acceso Premium desbloquea todo el contenido de la plataforma.</li>
            </ul>
          </section>

          {/* 4 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              4. Política de reembolso
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Puede solicitar un reembolso dentro de los 7 días posteriores a su compra, siempre que no haya completado más del 25% del contenido del programa. Para solicitar un reembolso, envíe un correo a cfi.nomadlexis@gmail.com.
            </p>
          </section>

          {/* 5 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              5. Propiedad intelectual
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Todo el contenido de la plataforma (textos, audios, ejercicios, imágenes, videos y material didáctico) es propiedad exclusiva de NomadLexis y está protegido por las leyes de derechos de autor. Queda prohibido reproducir, distribuir o compartir el contenido sin autorización escrita previa.
            </p>
          </section>

          {/* 6 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              6. Conducta del usuario
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              El usuario se compromete a:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Utilizar la plataforma únicamente con fines educativos</li>
              <li>No compartir su cuenta con terceros</li>
              <li>Respetar a los demás usuarios en los talleres en vivo</li>
              <li>No intentar acceder a los sistemas de forma no autorizada</li>
            </ul>
          </section>

          {/* 7 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              7. Certificado
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Al completar el programa, los estudiantes que aprueben las evaluaciones requeridas recibirán un certificado digital de Francés Aplicado, verificable en línea. Este certificado acredita la finalización del programa, pero no constituye un título oficial reconocido por el Estado.
            </p>
          </section>

          {/* 8 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              8. Limitación de responsabilidad
            </h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>NomadLexis no garantiza resultados de aprendizaje específicos.</li>
              <li>El servicio puede estar temporalmente no disponible por mantenimiento.</li>
              <li>NomadLexis no es responsable por interrupciones causadas por terceros (alojamiento, pagos, etc.).</li>
            </ul>
          </section>

          {/* 9 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              9. Cancelación de cuenta
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              El usuario puede solicitar la eliminación de su cuenta en cualquier momento enviando un correo a cfi.nomadlexis@gmail.com. NomadLexis se reserva el derecho de suspender o cancelar una cuenta en caso de incumplimiento de estos términos.
            </p>
          </section>

          {/* 10 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              10. Jurisdicción
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Estos términos se rigen por las leyes de la República de Chile. Cualquier controversia será sometida a los tribunales competentes de Chile.
            </p>
          </section>

          {/* 11 */}
          <section>
            <h2 className="text-xl font-semibold mb-3">
              11. Contacto
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Para cualquier consulta sobre estos términos, contáctenos en:
            </p>
            <p className="font-medium mt-2">cfi.nomadlexis@gmail.com</p>
          </section>
        </div>
      </main>
    </div>
  )
}
